// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-details .el-tabs__nav-prev, .booking-details .el-tabs__nav-next {\n  line-height: 29px;\n}\n.booking-details .el-tabs__content {\n  overflow: auto;\n}\n.booking-details .el-tab-pane {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
